import React from 'react';

function PdfCover({ data, officeName, dateLabel, yearLabel }) {
  return (
    <div className="cover-art c3">
      <div className="c3__left">
        <div className="c3__top">
          <div className="brand"><span>{officeName}</span></div>
        </div>
        <div className="c3__center">
          <div className="c3__title-wrap">
            <h1 className="c3__title serif" style={{ wordBreak: 'keep-all' }}>{data.title}</h1>
            {data.address && <div className="c3__sub">{data.address}</div>}
          </div>
          <div className="c3__vline">{yearLabel}</div>
        </div>
        <div className="c3__bottom">
          <span>Property Report <span style={{ color: 'var(--c-ink-muted)', textTransform: 'none' }}>@ disco.re</span></span>
          <span className="num">{dateLabel}</span>
        </div>
      </div>
      <div className={`c3__photo ${data.coverImageUrl ? 'photo' : ''}`} style={{ position: 'relative', overflow: 'hidden', background: data.coverImageUrl ? undefined : '#faf7ef' }}>
        {data.coverImageUrl && (
          <img src={data.coverImageUrl} crossOrigin="anonymous" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        )}
      </div>
    </div>
  );
}

export default PdfCover;
